// Load the theme modules from the versioned URLs the layout uses. A plain './theme.js' is another module URL:
// the browser would download and run a second copy, which the CDN may serve from an older deploy.
const layoutModuleUrl = (file) =>
  document.querySelector(`script[type="module"][src*="/assets/${file}"]`)?.src ??
  new URL(`./${file}`, import.meta.url).href;

const [{ animate, inView }, { getHeadingKeyframe }] = await Promise.all([
  import(layoutModuleUrl('vendor.min.js')),
  import(layoutModuleUrl('theme.js')),
]);

class RichContent extends HTMLElement {
  connectedCallback() {
    const heading = this.querySelector('[reveal-on-scroll="true"]');

    if (!heading || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      return;
    }

    inView(
      this,
      () => {
        const headingKeyframe = getHeadingKeyframe(heading);

        if (headingKeyframe.length > 0) {
          animate(...headingKeyframe);
        }
      },
      { margin: '0px 0px -100px 0px' }
    );
  }
}

if (!window.customElements.get('rich-content')) {
  window.customElements.define('rich-content', RichContent);
}
